
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Token } from "../../model/token";
import { SyncDataDTO } from "../../model/sync";
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { CONFIG } from '../../constants/constants';

/*Servicio para sincronizacion de respuestas entre bases de datos*/
@Injectable({
    providedIn: 'root'
})
export class SyncService {

    //Constructor de la clase
    constructor(private http: HttpClient) {
        this.http = http;
    }

    /*Metodo principal de la sincronizacion,
    invoca un servicio de plexi-rest que se encarga de enviar las
    respuestas a la base de datos central de la aplicacion*/
    public syncData(token: string, userName: string): Promise<SyncDataDTO> {
        let resp: any;
        let _headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'token': token,
            'user': userName
        });
        return this.http.get<SyncDataDTO>(CONFIG.REST_END_POINT + 'syncData/',
            { headers: _headers }).toPromise();

    }

}
